import { hubConfig, iframeConfig, typesConfig, widgetConfig } from "./config";
import { iframeHelper, loggingHelper, storageHelper } from "./helper";
import { iframeController, hubController } from "./controller";

let keys = {};

export const widget = (function () {
	let frames = {};

	function initIframe({ apiKey, data, hidden, open }) {
		frames = iframeController.initWidget({ hidden });
		hubController.initHub(frames);
		hubController.emitWidgetInitialization({ frames, apiKey, data, open });
	}
	function initFlowsIframe({ apiKey, data, container }) {
		frames = iframeController.initFlows({ container });
		hubController.initFlowHub(frames);
		hubController.emitFlowInitialization({ frames, apiKey, data });
	}
	function hideFrames() {
		if (!frames) {
			return;
		}

		hubController.disableListeners();

		for (let key of Object.keys(frames)) {
			if (key !== typesConfig.apps.flow) {
				iframeHelper.hideFrame(frames[key]);
			}
		}

		widget.hidden = true;
		widget.forceHide = true;
	}

	function addNewInitKey({ apiKey, app }) {
		if (!keys[apiKey]) {
			keys[apiKey] = new Set();
		}

		keys[apiKey].add(app);
	}

	return {
		init: async ({ apiKey }) => {
			hubController.watchIfDocumentIsReady(() => {
				const script = document.createElement("script");

				script.src = "https://manager.widget-hub.bothive.be";
				script.onload = () => window.IntentManager.widget.init({ apiKey });

				document.body.appendChild(script);
			});
		},
		initFlowPage: async ({ apiKey, data, config }) => {
			const app = typesConfig.apps.flow;

			if (keys[apiKey] && keys[apiKey].has(app)) {
				loggingHelper.warn("Widget init flow page can only be called once");
				return;
			}

			if (data && data.language) {
				window.language = data.language;
				storageHelper.setState({ language: data.language });
			}

			if (!apiKey) {
				loggingHelper.error(`${widgetConfig.loggingName}: ${widgetConfig.errors.noApiKey}`);
				return;
			}

			try {
				addNewInitKey({ apiKey, app: typesConfig.apps.flow });

				hubController.watchIfDocumentIsReady(() => {
					if (iframeHelper.existingFramesPresent([iframeConfig.frameId.flow])) {
						if (logging) {
							loggingHelper.warn(`${widgetConfig.loggingName}: ${widgetConfig.warnings.alreadyLoaded}`);
						}
						return;
					}

					initFlowsIframe({ apiKey, data, container: config.container });
					widget.initialized = true;
				});
			} catch (error) {
				loggingHelper.logApiKeyError(error);
				return;
			}
		},
		hide: hideFrames,
		show() {
			if (!frames || !Object.keys(frames).length) {
				return;
			}

			hubController.enableListeners();

			for (let key of Object.keys(frames)) {
				if (key !== typesConfig.apps.flow) {
					iframeHelper.showFrame(frames[key]);
				}
			}

			widget.hidden = false;
			widget.forceHide = false;
		},
		refresh() {
			hubController.emitRefresh(frames);
		},
		setLanguage(language) {
			hubController.emitLanguageChange({ frames, payload: { language } });
			hubController.updateLanguage({ frames, language });
		},
		onWidgetOpen(callback) {
			hubController.setControllerOptions({ key: [hubConfig.controllerOptions.onWidgetOpen], value: callback });
		},
		onWidgetClose(callback) {
			hubController.setControllerOptions({ key: [hubConfig.controllerOptions.onWidgetClose], value: callback });
		},
		open() {
			hubController.emitOpenWidget({ frames });
		},
		close() {
			hubController.emitCloseWidget({ frames });
		},
		disableNotifications: hubController.enableNotifications,
		enableNotifications: hubController.disableNotifications,
		logHistory: loggingHelper.getLogs,
		initialized: false,
		hidden: true,
	};
})();

if (process.env.NODE_ENV === "development") {
	widget.init({ apiKey: "1541507771627-ZgWVH0C28RO4JBP34WazhImXBwRHWRzo" });
	// widget.initFlowPage({
	// 	apiKey: "1541507771627-ZgWVH0C28RO4JBP34WazhImXBwRHWRzo",
	// 	config: { container: "body" },
	// });
}
